import { render } from "./FaceCard.vue?vue&type=template&id=9ee8e1fa&scoped=true"
import script from "./FaceCard.vue?vue&type=script&lang=js"
export * from "./FaceCard.vue?vue&type=script&lang=js"

import "./FaceCard.vue?vue&type=style&index=0&id=9ee8e1fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ee8e1fa"]])

export default __exports__